package com.evoapps.evoshift.domain.util

import org.khronos.webgl.Uint8Array
import org.khronos.webgl.get

/**
 * `globalThis.crypto.getRandomValues`: the Web Crypto API in the browser and, since Node 19, in
 * Node too (the end-to-end suite, e2e/, runs the domain module there). Node's older
 * `require("crypto")` is not used: a `require` call would make the browser bundle look for a Node
 * module, and the project needs Node 24 anyway (firebase/tests/package.json).
 */
actual fun secureRandomBytes(n: Int): ByteArray {
    val crypto = js("globalThis.crypto")
    check(crypto != null && crypto.getRandomValues != null) { "No cryptographic random source (crypto.getRandomValues)" }
    val array = Uint8Array(n)
    crypto.getRandomValues(array)
    return ByteArray(n) { array[it] }
}
